import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  FaBarcode,
  FaCalendarAlt,
  FaEnvelope,
  FaLock,
  FaPhoneAlt,
  FaUser,
  FaUserSecret,
  FaCaretDown,
  FaCamera,
  FaPencilAlt,
} from "react-icons/fa";
import {
  checkUserAccessAndToken,
  getHeaderForAxios,
  getToken,
} from "../../common/getLocalStorageData";
import { NORMAL_USER_ACCESS } from "../../constant/FrontEnd";
import IUser from "../../interfaces/user";
import DatePicker from "react-datepicker";
import { validatePhone } from "../../common/phoneCheck";
import EncryptData from "../../common/encryption";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";
import {
  PROFILE_MYPROFILE,
  SIDE_MENU_PROFILE,
} from "../../constant/menuAndProfile";
import GetActiveDealAdvertisement from "../../common/getActiveDealAdvertisement";
import GetAdvertisementElement from "../../common/getAdvertisementElement";
import "../../assets/css/scss/component/_advertisement.scss";

const errorFieldList = {
  name: "",
  email: "",
  countryCode: "",
  phone: "",
  birthDate: "",
  address: "",
  submit: false,
};
export const UpdateProfile = (props: IUser | any) => {
  const [isPageEdit, setIsPageEdit] = useState(false);
  const [email, setEmail] = useState(props.email);
  const [phone, setPhone] = useState(props.phone);
  const [birthday, setBirthday] = useState(
    props.birthday && props.birthday !== "0000-00-00"
      ? new Date(props.birthday.replace("T", " ").replace("Z", " "))
      : null
  );
  const [name, setName] = useState(props.name);
  const [profile, setProfile] = useState(
    props.profile_image ||
      "https://lcd-images-public.s3.ap-south-1.amazonaws.com/user_profiles/default-user-profile-image.png"
  );
  const [reloadProfileFlag, setReloadProfileFlag] = useState(false);
  const accessUser = checkUserAccessAndToken(NORMAL_USER_ACCESS);
  const [selectedCountry, setCountry] = useState({
    countryCode: props.country_code,
    countryId: props.cs_id ?? parseInt(props.cs_id),
  });
  const [countryData, setCountryData] = useState([]);
  const [errorList, setErrorList] = useState(errorFieldList);
  const [birthDateDummy, setBirthDateDummy] = useState(birthday);
  const [profileAdvertisement, setProfileAdvertisement] = useState({});
  const [responseMessage, setResponseMessage] = useState({
    message: "",
    type: "",
  });
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLanguage = globalState?.selectedLang;
  const globalActiveAdv = useSelector(
    (state: IReduxStateData) => state.activeDealAdvertisement
  );
  useEffect(() => {
    const fetchData = async () => {
      var iso_code: string = "";
      if (!selectedCountry.countryId) {
        await axios
          .get(process.env.REACT_APP_API_URL + "/common/find-trace")
          .then(function (response) {
            // handle success
            if (response.data?.success) {
              if (
                response.data.success?.[
                  process.env.REACT_APP_COUNTRY_PARAMETER ?? ""
                ]
              ) {
                iso_code =
                  response.data.success[
                    process.env.REACT_APP_COUNTRY_PARAMETER ?? ""
                  ].trim();
              }

              // Optional: You can also access other trace data
              // const userIP = response.data.data.ip;
              // const dataCenter = response.data.data.colo;
              // const timestamp = response.data.data.timestamp;
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
      }

      if (countryData && !countryData.length) {
        await axios
          .get(process.env.REACT_APP_API_URL + "/common/get-country-list")
          .then(function (response) {
            // handle success
            if (response.data && response.data.success) {
              setCountryData(response.data.success);
              filterCountryData(
                selectedCountry.countryId,
                iso_code,
                response.data.success
              );
            }
          });
      } else {
        filterCountryData(selectedCountry.countryId, iso_code, countryData);
      }
    };
    fetchData();
    setPaddingProfileWrapper();
  }, []);
  useEffect(() => {
    if (globalActiveAdv) {
      const advertisementForPage = GetActiveDealAdvertisement(
        globalState,
        1,
        1
      );
      setProfileAdvertisement(advertisementForPage || {});
    }
  }, [globalActiveAdv]);

  const checkValidationSubmit = (e: any, isSubmit: boolean = true) => {
    const errorData = { ...errorFieldList };
    let isValidateForm = true;
    if (!name) {
      isValidateForm = false;
      errorData["name"] = "Please enter full name";
    }
    if (!email) {
      isValidateForm = false;
      errorData["email"] = "Please enter valid email address";
    }
    if (!phone || !validatePhone(selectedCountry.countryCode + phone)) {
      isValidateForm = false;
      errorData["phone"] = "Please enter valid phone";
    }
    if (!birthday && birthday !== birthDateDummy) {
      isValidateForm = false;
      errorData["birthDate"] = "Please enter valid birth Date";
    }
    if (isValidateForm && isSubmit) {
      submitRegisterData(e);
      setErrorList(errorData);
      setIsPageEdit(false);
    } else {
      errorData["submit"] = true;
      setErrorList(errorData);
    }
    // setToggleFlag(!toggleFlag)
  };

  const uploadProfile = (e: any) => {
    e.preventDefault();
    if (isPageEdit) {
      const profileEle = document.getElementById(
        "uploadProfile"
      ) as HTMLInputElement;
      profileEle.click();
      e.preventDefault();
    }
  };

  const getFileExtension = (filename: string) => {
    // get file extension
    const extension = filename.substring(
      filename.lastIndexOf(".") + 1,
      filename.length
    );
    return extension;
  };

  const changeProfile = async (e: any) => {
    e.preventDefault();
    const formData = new FormData();
    const fileObj = e.target.files[0];
    if (fileObj) {
      formData.append(
        "file",
        fileObj,
        props.uuid + "." + getFileExtension(fileObj.name).toLowerCase()
      );
      await axios
        .post(
          process.env.REACT_APP_API_URL + "/auth/change-profile-picture",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              auth: getToken(),
            },
          }
        )
        .then(function (response) {
          if (response.data) {
            if (response.data?.message) {
              setResponseMessage({
                message: response.data.message,
                type: "success",
              });
              setTimeout(() => {
                setResponseMessage({ message: "", type: "" });
              }, 10000);
            }
            if (response.data?.success?.path) {
              setProfile(response.data.success.path);
              setReloadProfileFlag(!reloadProfileFlag);
              localStorage.setItem(
                "loginData",
                JSON.stringify(
                  EncryptData({
                    token: getToken(),
                    user: {
                      ...props,
                      profile_image: response.data.success.path,
                    },
                  })
                )
              );
            }
          }
        })
        .catch(function (error) {
          console.log(error);
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            setResponseMessage({
              message: error.response.data.message,
              type: "error",
            });
            setTimeout(() => {
              setResponseMessage({ message: "", type: "" });
            }, 10000);
          }
          // setLoading(false);
        });
    }
  };
  const submitRegisterData = async (e: any) => {
    e.preventDefault();
    const data: any = {
      user_uuid: props.uuid,
      name: name,
      email: email,
      phone: phone,
      birthday: birthday?.toISOString().replace("T", " ").replace("Z", " "),
      country_code: selectedCountry.countryId,
    };
    const newData = {
      uuid: props.uuid,
      name: name,
      phone: phone,
      birthday: birthday?.toISOString().replace("T", " ").replace("Z", " "),
      cs_id: selectedCountry.countryId,
      country_code: selectedCountry.countryCode,
    };
    await axios
      .post(process.env.REACT_APP_API_URL + "/auth/change-profile", data, {
        headers: getHeaderForAxios(),
      })
      .then(function (response) {
        if (response.data.message) {
          setResponseMessage({
            message: response.data.message,
            type: "success",
          });
          setTimeout(() => {
            setResponseMessage({ message: "", type: "" });
          }, 10000);
          localStorage.setItem(
            "loginData",
            JSON.stringify(
              EncryptData({ token: getToken(), user: { ...props, ...newData } })
            )
          );
        }
      })
      .catch(function (error) {
        console.log(error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setResponseMessage({
            message: error.response.data.message,
            type: "error",
          });
          setTimeout(() => {
            setResponseMessage({ message: "", type: "" });
          }, 10000);
        }
        // setLoading(false);
      });
  };
  const onChangeForm = (e: any, isNextClick: boolean = false) => {
    // if (errorList?.next || errorList?.submit)
    //   checkValidationSubmit(e, isNextClick, false);
  };

  const filterCountryData = (countryId: number, isoCode = "", data = []) => {
    if (data) {
      let fetchCountryCode = "";
      let fetchCountryId = 0;
      if (countryId) {
        data.filter(function (data: any, index: number) {
          if (data.id === countryId) {
            fetchCountryCode = data.country_code;
            fetchCountryId = countryId;
          }
        });
      } else if (isoCode) {
        data.filter(function (data: any, index: number) {
          if (data.iso_code.toString() === isoCode) {
            fetchCountryId = data.id;
            fetchCountryCode = data.country_code;
          }
        });
      }
      setCountry({
        countryCode: fetchCountryCode,
        countryId: fetchCountryId,
      });
    }
  };
  const setPaddingProfileWrapper = () => {
    const headerEle = document.getElementsByClassName(
      "navbar-light"
    )[0] as HTMLElement;
    if (headerEle) {
      const widthEle = headerEle.offsetWidth;
      const calculatedWidth = (window.innerWidth - widthEle) / 2;
      const rigthWrapper = document.getElementById("right-side-element");
      if (rigthWrapper && calculatedWidth) {
        rigthWrapper.style.paddingRight = calculatedWidth + "px";
      }
    }
  };
  const getOptions = () => {
    let countryDropDownData: any[] = [];
    countryData?.map((data: any, index) => {
      const optionValue =
        data["country_code"].padEnd(5) + " " + data["country_name"];
      countryDropDownData.push(
        <option
          selected={
            selectedCountry.countryId == parseInt(data["id"]) ? true : false
          }
          value={index}
          label={data["country_code"].slice(1, 5)}
        >
          {optionValue}
        </option>
      );
    });
    return countryDropDownData;
  };
  const setSelectedCountry = (countryIndex: number) => {
    if (countryData && countryData[countryIndex]) {
      setCountry({
        countryCode: countryData[countryIndex]["country_code"],
        countryId: countryData[countryIndex]["id"],
      });
    }
  };
  return (
    <Fragment>
      <div className="right-side-header-main">
        <div className="right-side-header">
          {SIDE_MENU_PROFILE[selectedLanguage]?.my_profile}
        </div>
        {!isPageEdit ? (
          <span
            className="right-side-header-icon"
            onClick={() => setIsPageEdit(true)}
          >
            <FaPencilAlt />
          </span>
        ) : null}
      </div>
      <hr />
      <Row className="right-side-wrapper">
        <Col sm={3} className="right-side-column">
          <div className="right-side-img">
            <Fragment key={reloadProfileFlag ? "true" : "false"}>
              <img alt="" className="profile-image" src={profile} />
            </Fragment>
            {isPageEdit ? (
              <Fragment>
                <div
                  className="right-side-img-bottom pointer"
                  onClick={(e) => uploadProfile(e)}
                >
                  <FaCamera />{" "}
                  {PROFILE_MYPROFILE[selectedLanguage].upload_photo}
                </div>
                <input
                  id="uploadProfile"
                  accept="image/*"
                  type="file"
                  name="user-profile"
                  className="d-none"
                  onChange={(e) => changeProfile(e)}
                />
              </Fragment>
            ) : null}
          </div>
        </Col>
        <Col sm={9} className="user-form-div">
          {responseMessage.message ? (
            <div
              className={
                responseMessage.type === "success"
                  ? "form-response success"
                  : "form-response error"
              }
            >
              {responseMessage.message}
            </div>
          ) : null}
          <Form>
            <Fragment>
              <Form.Group
                className={`form-group ${name ? "focus" : ""} ${
                  errorList.submit
                    ? errorList.name
                      ? "field-group-error"
                      : "field-group-success"
                    : ""
                }`}
                controlId="formName"
              >
                <Form.Label>
                  {PROFILE_MYPROFILE[selectedLanguage].name}
                </Form.Label>
                <Form.Control
                  type="text"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    onChangeForm(e, true);
                  }}
                  className={`${!isPageEdit ? "disabled" : ""} ${
                    errorList.submit
                      ? errorList.name
                        ? "focus-error"
                        : "focus-success"
                      : ""
                  }`}
                  disabled={!isPageEdit ? true : false}
                />
                <span className="input-append">
                  <FaUser />
                </span>
              </Form.Group>
              <Form.Group
                className={`form-group ${email ? "focus" : ""} ${
                  errorList.submit
                    ? errorList.email
                      ? "field-group-error"
                      : "field-group-success"
                    : ""
                }`}
                controlId="formBasicEmail"
              >
                <Form.Label>
                  {PROFILE_MYPROFILE[selectedLanguage].email}
                </Form.Label>
                <Form.Control
                  type="email"
                  autoComplete="new-email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    onChangeForm(e, true);
                  }}
                  className={`${!isPageEdit ? "disabled" : ""} ${
                    errorList.submit
                      ? errorList.email
                        ? "focus-error"
                        : "focus-success"
                      : ""
                  }`}
                  disabled={!isPageEdit ? true : false}
                />
                <span className="input-append">
                  <FaEnvelope />
                </span>
              </Form.Group>
              <Form.Group
                className={`form-group focus ${
                  errorList.submit
                    ? errorList.phone
                      ? "field-group-error"
                      : "field-group-success"
                    : ""
                }`}
                controlId="formNumber"
              >
                <Form.Label>
                  {PROFILE_MYPROFILE[selectedLanguage].phone_no}
                </Form.Label>
                {countryData.length ? (
                  <Form.Select
                    id="formNumberOption"
                    className={`custom-select ${!isPageEdit ? "disabled" : ""}`}
                    aria-label="Default select example"
                    onChange={(e) => {
                      setSelectedCountry(parseInt(e.target.value));
                    }}
                    size="sm"
                    disabled={!isPageEdit ? true : false}
                  >
                    {getOptions()}
                  </Form.Select>
                ) : null}
                <Form.Control
                  type="number"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    onChangeForm(e, true);
                  }}
                  className={`custom-phone-input ${
                    !isPageEdit ? "disabled" : ""
                  } ${
                    errorList.submit
                      ? errorList.phone
                        ? "focus-error"
                        : "focus-success"
                      : ""
                  }`}
                  disabled={!isPageEdit ? true : false}
                />
                <span className="input-append">
                  <FaPhoneAlt />
                </span>
              </Form.Group>
              <Form.Group
                className={`form-group ${birthDateDummy ? "focus" : ""} ${
                  errorList.submit
                    ? errorList.birthDate
                      ? "field-group-error"
                      : "field-group-success"
                    : ""
                }`}
                controlId="formBirthday"
              >
                <Form.Label>
                  {PROFILE_MYPROFILE[selectedLanguage].birthdate}
                </Form.Label>
                <DatePicker
                  dateFormat={"dd/MM/yyyy"}
                  maxDate={date}
                  selected={birthday}
                  onChange={(date: any) => {
                    setBirthday(date);
                  }}
                  customInput={
                    <Form.Control
                      type="text"
                      onChange={(date: any) => setBirthDateDummy(date)}
                      className={`${!isPageEdit ? "disabled" : ""} ${
                        errorList.submit
                          ? errorList.birthDate
                            ? "focus-error"
                            : "focus-success"
                          : ""
                      }`}
                      disabled={!isPageEdit ? true : false}
                    />
                  }
                  disabled={!isPageEdit ? true : false}
                />
                <span className="input-append">
                  <FaCalendarAlt />
                </span>
              </Form.Group>
              {/* <Form.Group className='form-group'>
                                <Form.Label>Address</Form.Label>
                                <Form.Control as="textarea" className={`${!isPageEdit ? "disabled" : ""}`} disabled={!isPageEdit ? true : false} />
                                <span className="input-append">
                                    <FaAddressBook />
                                </span>

                            </Form.Group> */}
              {isPageEdit ? (
                <Form.Group className="form-group">
                  <Button
                    type="button"
                    className="font-semibold btn btn-save d-inline w-75"
                    onClick={(e) => {
                      checkValidationSubmit(e, true);
                    }}
                  >
                    {SIDE_MENU_PROFILE[selectedLanguage].save}
                  </Button>
                  <Button
                    type="button"
                    className="font-semibold btn btn-save d-inline w-25 cancel-btn"
                    onClick={(e) => {
                      setIsPageEdit(false);
                    }}
                  >
                    {SIDE_MENU_PROFILE[selectedLanguage].cancel}
                  </Button>
                </Form.Group>
              ) : null}
            </Fragment>
          </Form>
        </Col>
        <Col sm={12} className="pl-0 pr-0">
          {Object.keys(profileAdvertisement).length ? (
            <div
              className="advertisement-wrapper adv-image mb-3"
              style={{ height: "200px", width: "100%" }}
            >
              <GetAdvertisementElement {...profileAdvertisement} />
            </div>
          ) : null}
        </Col>
      </Row>
    </Fragment>
  );
};
